import { Toro } from '../common/enumerations';
import { Auxiliary } from './auxiliary.model';
import { ControllerClimateLogicSettings } from './controller-climate-logic-settings.model';
import { ControllerClimateLogicStatus } from './controller-climate-logic-status.model';
import { Kd2SpecificConfiguration } from './kd2-specific-configuration.model';
import ModeSwitchPosition = Toro.ModeSwitchPosition;
import { ProgramMonthlyAdjustmentModel } from './program-monthly-adjustment.model';
import { RunningState } from './running-state.model';
import { ToroControllerPreferencesModel } from './toro-controller-preferences.model';
import { ToroProgram } from './toro-program.model';
import { ToroRainSensorModel } from './toro-rain-sensor.model';
import { ToroSoilSensorModel } from './toro-soil-sensor.model';
import { ToroStation } from './toro-station.model';
import { ToroWeatherSensorModel } from './toro-weather-sensor.model';
import { LxcSettings } from './lxc-specific.model';

export class ToroControllerConfiguration {
    private _programs: ToroProgram[] = [];
    private _stations: ToroStation[] = [];
    private _auxiliaries: Auxiliary[] = [];

    //TODO LXC
    //DailyCounterBlock: any;
    //FlowSensorLearnConfigrations:any;     //ToroFlowLearnConfigModel
    LxcSettings?:LxcSettings;
    RainSensor2?: ToroRainSensorModel;

    constructor(json: any = null) {
        if (json) {
            // Map the json object to 'this' objects properties.
            Object.assign(this, json);

            this.Preferences = new ToroControllerPreferencesModel(json['Preferences']);
            this.ClimateLogicSettings = new ControllerClimateLogicSettings(json.ClimateLogicSettings);
            this.ClimateLogicStatus = new ControllerClimateLogicStatus(json.ClimateLogicStatus);
            this.KD2Specific = new Kd2SpecificConfiguration(json.KD2Specific);
            this.RunningState = new RunningState(json.RunningState);
        }

    }

    // TODO: Complete model as appropriate

    public AddedAsLegacy = false;
    public AdditionalInformation: any[];                                   // Todo: Add correct model
    public AlarmMvIsShorted = false;
    public AllStations: ToroStation[];
    public AutoProgramAdjust: number;
    public AuxRelay1Id: number;
    public AuxRelay2Id: number;
    public AvailableNumberOfStations = 4;
    public AvailableStationsByNumber: number[];
    public ClimateLogicSettings: ControllerClimateLogicSettings;
    public ClimateLogicStatus: ControllerClimateLogicStatus;
    public ConflictedPin: any;                                              // Todo: Replace w/correct type.
    public DefaultStationRunTime = 10;
    public DoesServerHaveUnsyncedChanges = false;                           // Todo: Add correct model
    public ExtendedStationInfo: any[];                                      // Todo: Add correct model
    public GlobalWaterAdjustment: number;
    public HasBeenDecomposedFromRecords = false;
    public ImageUrl: string;
    public IsAnythingRunning = false;
    public KD2Specific: Kd2SpecificConfiguration;
    public ManualRunTimePerStation = 10;
    public MaximumStationRunTime = 240;
    public ModeSwitchX: ModeSwitchPosition;
    public Preferences: ToroControllerPreferencesModel;
    public ProgramLabelText = 'ToroProgram';
    public ProgramsHeaderText = 'Programs';
    public RainSensor: ToroRainSensorModel;
    public RemainingRunningTimeForProgram: number;
    public RemainingRunningTimeForStation: number;
    public RunningMode: number;                                             // Todo: Replace with correct type (enum).
    public RunningModeDaysToRemainOff: number;
    public RunningProgramNumber: number;
    public RunningState: RunningState;
    public RunningStationNumber: number;
    public SoilSensors: ToroSoilSensorModel[];
    public StationLabelText = 'ToroStation';
    public StationsHeaderText = 'Stations';
    public WaterRestrictionHour: number;
    public WaterRestrictionTime: number;
    public WeatherSensor: ToroWeatherSensorModel;


    public get Programs(): ToroProgram[] { return this._programs; }

    public set Programs(value) {
        this._programs.length = 0;
        value.forEach(program => {
            this._programs.push(new ToroProgram(program));
        });
    }

    public get Stations(): ToroStation[] { return this._stations; }

    public set Stations(value) {
        this._stations.length = 0;
        value.forEach(station => {
            this._stations.push(new ToroStation(station));
        });
    }

    public get Auxiliaries(): Auxiliary[] { return this._auxiliaries; }

    public set Auxiliaries(value) {
        this._auxiliaries.length = 0;
        value.forEach(auxiliary => {
            this._auxiliaries.push(new Auxiliary(auxiliary));
        });
    }

    public get DisplayedStations(): ToroStation[] {
        return this._stations.filter(station => station.IsDisplayed === true);
    }

    public get ModeSwitchXString(): string {
        switch (this.ModeSwitchX) {
            case ModeSwitchPosition.OffOrStop:
                return 'Off or Stop';
            case ModeSwitchPosition.RunOrManual:
                return 'Run Or Manual';
            case ModeSwitchPosition.RunOrProgram:
                return 'Run Or Program';
            case ModeSwitchPosition.SetProgram:
                return 'Set Program';
            default:
                return 'Off or Stop';
        }
    }

    public get ControllerMonthlyConfiguration(): ProgramMonthlyAdjustmentModel {
        // Since all the programs have the same value for monthly adjustment, only difference is the ActivatePerMonthWaterBudget flag,
        // we look for the first program with this flag active and return its data

        if (!this.Programs || this.Programs.length === 0) {
            return new ProgramMonthlyAdjustmentModel({
                January: 0,
                February: 0,
                March: 0,
                April: 0,
                May: 0,
                June: 0,
                July: 0,
                August: 0,
                September: 0,
                October: 0,
                November: 0,
                December: 0
            });
        }
        const programWithActiveWaterBudget = this.Programs.find(program => program.ActivatePerMonthWaterBudget === true);
        return programWithActiveWaterBudget ? programWithActiveWaterBudget.MonthlyAdjustment : this.Programs[0].MonthlyAdjustment;
    }

}

